export default __webpack_public_path__ + "static/16-5dc62378f39bf3b478e9054032647a46.jpg";